import { SearchLocationPlaceResponse } from '../types/api-responses/search-location-response'
import { AirportModel } from '../types/models/airport.model'

export function searchLocationResolver(
  location: SearchLocationPlaceResponse,
): AirportModel
export function searchLocationResolver(
  location: SearchLocationPlaceResponse[],
): AirportModel[]

export function searchLocationResolver(
  location: SearchLocationPlaceResponse | SearchLocationPlaceResponse[],
): AirportModel | AirportModel[] {
  if (Array.isArray(location)) {
    return location.map(resolveAirport)
  }
  return resolveAirport(location)
}

function resolveAirport(place: SearchLocationPlaceResponse): AirportModel {
  return {
    address: place.formattedAddress,
    latitude: place.location.latitude.toString(),
    longitude: place.location.longitude.toString(),
    name: place.displayName.text,
    place_id: place.id,
    types: place.types,
    city: place.city
      ? {
          countryId: place.city.country_id,
          countryName: place.city.country_name,
          timeZone: place.city.timezone,
        }
      : null,
  }
}
